module.exports = "/static/assets/2659c05c51412f56c36a02beb5758cac.png";